// WDCE-199 step 9e: whether OrderForm saves the browser's guess at the card brand before a checkout. On a POS order
// only for credit card: the guess means nothing for cash or EFTPOS (the server ignores it, and EFTPOS records the
// brand from the PIN pad). Other order types send it for every payment type, as before.
export function sendsCardBrandGuess(orderType, paymentType) {
  return orderType !== 'pos' || paymentType === 'credit_card'
}
